import './BoxTitle.scss'
import { ReactElement } from 'react'

interface BoxTitleProps {
  icon?: string
  color?: string
  title: string
  titleContent?: ReactElement
  labelFilter?: string
  iconFilter?: string
}
export default function BoxTitle(props: BoxTitleProps) {
  const { icon, color, title, titleContent } = props
  return (
    <div className={`custom-box-title ${color ?? ''} `}>
      <div className="leftTitle">
        <span>
          {icon ? <i className={icon} /> : undefined} {title}
        </span>
      </div>
      {titleContent ? <div className="rightTitle">{titleContent}</div> : undefined}
    </div>
  )
}
